import request from 'helpers/request';
// eslint-disable-next-line import/no-unresolved
import api from 'config';

export const paymentReasonList = async (params) => {
  const { data } = await request({
    url: `${api.config.companyAPI}/coupon/v1/user/reason`,
    params
  });
  return data;
};

export const updatePaymentReason = (data) =>
  request({
    method: 'POST',
    url: `${api.config.companyAPI}/coupon/v1/admin/reason`,
    data
  });
